<div class="container">
    <p>If you have denied geolocation access to the app, you will have to re-enable it to allow auto filling location data on sets.</p>
    <p>The process to do so differs on Android and iOS systems. Images here may not apply to every device model even within identical operating systems and should be taken as a general visual aid.</p>

    <h2 class="help-header">For Android Devices</h2>

    <ul>
        <li>Open your device's Settings app and go to the 'Security and Privacy' tab. Within that click on the 'Privacy' option.</li>
        <img [src]="getImgs[0]"
        class="help-img help-container"
           (click)="showImage(getImgs[0])" />

        <li>Click on the 'Permission manager' option and then on the 'Location' option</li>
        <img [src]="getImgs[1]"
        class="help-img help-container"
           (click)="showImage(getImgs[1])" />

        <img [src]="getImgs[2]"
        class="help-img help-container"
            (click)="showImage(getImgs[2])" />
   

        <li>Click on the 'Chrome' option</li>       
        <img [src]="getImgs[3]"
        class="help-img help-container"
            (click)="showImage(getImgs[3])" />

        <li>Click on 'Allow only while using the app'. Ensure that 'Use precise location' is enabled</li>
        <img [src]="getImgs[4]"
        class="help-img help-container"
           (click)="showImage(getImgs[4])" />
    </ul>

    <h2 class="help-header">For Apple/iOS Devices</h2>

    <ul>
        <li>Open your device's Settings app and go to the 'Privacy & Security' tab. Within that click on the 'Location Services' option.</li>
        <img [src]="getImgs[5]"
        class="help-img help-container"
           (click)="showImage(getImgs[5])" />

        <li>Ensure Location Services are enabled and that the option for Safari Websites is 'While Using the App'</li>
        <img [src]="getImgs[6]"
        class="help-img help-container"
           (click)="showImage(getImgs[6])" />

        <li>Back in the main Settings app menu go to the 'Safari' option further down.</li>
        <img [src]="getImgs[7]"
        class="help-img help-container"
           (click)="showImage(getImgs[7])" />

        <li>With the 'Safari' menu got to Location and within there ensure the 'Allow' option is checked.</li>
        <img [src]="getImgs[8]"
        class="help-img"
           (click)="showImage(getImgs[8])" />

        <img [src]="getImgs[9]"
        class="help-img help-container"
           (click)="showImage(getImgs[9])" />

        <li>Within the app, if geolocation is still not working then refresh the app (swipe down gesture) or close and reopen the app.</li>
    </ul>
</div>